import QuizDetails from 'components/ViewQuiz/QuizDetails';
import QuizGradingPanel from 'components/ViewQuiz/QuizGradingPanel';
import { useTranslation } from 'react-i18next';
import { Button, Container, Drawer, Icon, Paper, Stack, styled, Text } from 'shell/components';

const ViewQuizLayout = ({ device, quiz, canManageQuiz, submissionImport, onBack, onEdit }) => {
    const { t } = useTranslation('quiz');
    const isDesktop = device === 'desktop';
    const editTooltip = !canManageQuiz
        ? { component: t('view.instructor-only-edit', 'Only instructors can edit quizzes.') }
        : undefined;

    const EditButton = (
        <Button
            disabled={!canManageQuiz}
            startIcon={<Icon kind={'edit'} />}
            tooltip={editTooltip}
            variant={'tertiary'}
            onClick={onEdit}
        >
            {t('common:controls.edit', 'Edit')}
        </Button>
    );

    return (
        <Container device={device}>
            <MainColumn $desktop={isDesktop} spacing={5}>
                {isDesktop ? (
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} spacing={4}>
                        <Button startIcon={<Icon kind={'arrowLeft'} />} variant={'borderless'} onClick={onBack}>
                            {t('common:controls.back', 'Back')}
                        </Button>
                        {EditButton}
                    </Stack>
                ) : (
                    <Button
                        sx={{ alignSelf: 'flex-start' }}
                        startIcon={<Icon kind={'arrowLeft'} />}
                        variant={'borderless'}
                        onClick={onBack}
                    >
                        {t('common:controls.back', 'Back')}
                    </Button>
                )}

                <Stack direction={'row'} alignItems={'flex-start'} justifyContent={'space-between'} spacing={4}>
                    <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                        {quiz.title || t('create.untitled', 'Untitled Quiz')}
                    </Text>
                    {!isDesktop && EditButton}
                </Stack>

                {!isDesktop && (
                    <GradingPaper variant={'outlined'}>
                        <QuizGradingPanel canManageQuiz={canManageQuiz} submissionImport={submissionImport} />
                    </GradingPaper>
                )}

                <DetailsPaper elevation={0} $mobile={device === 'mobile'}>
                    <QuizDetails quiz={quiz} />
                </DetailsPaper>
            </MainColumn>

            {isDesktop && (
                <Drawer device={'desktop'} variant={'persistent'} open>
                    <QuizGradingPanel canManageQuiz={canManageQuiz} submissionImport={submissionImport} />
                </Drawer>
            )}
        </Container>
    );
};

const MainColumn = styled(Stack, {
    shouldForwardProp: (prop) => prop !== '$desktop',
})(({ $desktop, theme }) => ({
    width: $desktop ? 'calc(100% - 444px)' : '100%',
    alignSelf: $desktop ? 'flex-start' : undefined,
    paddingBottom: theme.spacing(5),
}));

const DetailsPaper = styled(Paper, {
    shouldForwardProp: (prop) => prop !== '$mobile',
})(({ $mobile, theme }) => ({
    width: '100%',
    padding: theme.spacing($mobile ? 4 : 5),
    borderRadius: '16px',
}));

const GradingPaper = styled(Paper)(({ theme }) => ({
    width: '100%',
    padding: theme.spacing(4),
    borderRadius: '16px',
}));

export default ViewQuizLayout;
